export function rem(pixelValue, baseFontSize) {
  if (baseFontSize === void 0) {
    baseFontSize = 16;
  }

  return pixelValue / baseFontSize + "rem";
}
export function remRhythm(rhythmValue, baseFontSize, baseLineHeight) {
  if (baseFontSize === void 0) {
    baseFontSize = 16;
  }

  if (baseLineHeight === void 0) {
    baseLineHeight = 24;
  }

  return rem(rhythmValue * baseLineHeight, baseFontSize);
}
export function em(pixelValue, fontSize) {
  if (fontSize === void 0) {
    fontSize = 16;
  }

  return pixelValue / fontSize + "em";
}
export function emRhythm(rhythmValue, fontSize, baseLineHeight) {
  if (fontSize === void 0) {
    fontSize = 16;
  }

  if (baseLineHeight === void 0) {
    baseLineHeight = 24;
  }

  return em(rhythmValue * baseLineHeight, fontSize);
}